import { render, staticRenderFns } from "./parser-list.vue?vue&type=template&id=338b693d&scoped=true"
import script from "./parser-list.vue?vue&type=script&lang=js"
export * from "./parser-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338b693d",
  null
  
)

export default component.exports